/**
 * MENU_CONFIG — Fonte unica de verdade para menu, permissoes e rotas.
 */
import {
  LayoutDashboard, PlusCircle, Camera, ClipboardCheck, ClipboardList,
  ListTodo, Wrench, Building2, BarChart3, Users, Briefcase, Shield,
  CalendarDays, Settings, Award, Package, FolderTree, Truck, FileText,
  ShoppingBag, ShieldAlert, ShoppingCart, ArrowUpDown, Trophy, Banknote,
  Gauge, Flame, Coins, Layers, FileSearch, PackageCheck, Undo2,
  ClipboardSignature, PackagePlus, PackageSearch, Headphones, Warehouse,
  MessageSquare, ScrollText, CalendarClock, Receipt
} from 'lucide-react';

export const MENU_GROUPS = [
  {
    key: 'operacional',
    label: 'Operacional',
    defaultOpen: true,
    items: [
      { key: 'dashboard', icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard', permission: 'can_view_dashboard' },
      { key: 'new_call', icon: PlusCircle, label: 'Abrir Chamado', path: '/calls/new', permission: 'can_create_call' },
      { key: 'my_calls', icon: Headphones, label: 'Meus Chamados', path: '/my-calls' },
      { key: 'new_report', icon: Camera, label: 'Apontar Problema', path: '/reports/new', permission: 'can_create_report' },
      { key: 'validate_reports', icon: ClipboardCheck, label: 'Validar Reports', path: '/reports/validate', permission: 'can_validate_report' },
      { key: 'work_orders', icon: ClipboardList, label: 'Gestao de OS', path: '/work-orders', permission: 'can_assign_work_order' },
      { key: 'sector_queue', icon: ListTodo, label: 'Fila do Setor', path: '/departments/queue', permission: 'can_view_sector_queue' },
      { key: 'technicians_status', icon: Users, label: 'Painel de Tecnicos', path: '/technicians-status', permission: 'can_view_my_os' },
      { key: 'my_work_orders', icon: Wrench, label: 'Minhas OS', path: '/my-work-orders', permission: 'can_view_my_os' },
      { key: 'my_reports', icon: FileSearch, label: 'Meus Apontamentos', path: '/my-reports', permission: 'can_create_report' },
      { key: 'material_request', icon: PackagePlus, label: 'Solicitacao de Material', path: '/material-request', permission: 'can_request_material' },
    ],
  },
  {
    key: 'gestao',
    label: 'Gestao',
    defaultOpen: false,
    items: [
      { key: 'departments', icon: Building2, label: 'Setores', path: '/departments', permission: 'can_manage_departments' },
      { key: 'ceo_reports', icon: BarChart3, label: 'Relatorios CEO', path: '/ceo-reports', permission: 'can_view_ceo' },
      { key: 'work_schedule', icon: CalendarDays, label: 'Escala de Trabalho', path: '/work-schedule', permission: 'can_manage_work_schedule' },
      { key: 'routines', icon: CalendarClock, label: 'Rotinas Operacionais', path: '/routines', permission: 'can_assign_work_order' },
    ],
  },
  {
    key: 'usuarios_roles',
    label: 'Usuarios e Acessos',
    defaultOpen: false,
    items: [
      { key: 'users', icon: Users, label: 'Usuarios', path: '/users', permission: 'can_manage_users' },
      { key: 'job_roles', icon: Briefcase, label: 'Funcoes / Cargos', path: '/job-roles', adminOnly: true },
      { key: 'roles', icon: Shield, label: 'Cadastro de Roles', path: '/roles', adminOnly: true },
    ],
  },
  {
    key: 'estoque',
    label: 'Estoque',
    defaultOpen: false,
    items: [
      { key: 'materials', icon: Package, label: 'Materiais', path: '/materials', permission: 'can_manage_materials' },
      { key: 'material_categories', icon: FolderTree, label: 'Categorias', path: '/material-categories', permission: 'can_manage_materials' },
      { key: 'stock_movements', icon: ArrowUpDown, label: 'Movimentacoes', path: '/stock-movements', permission: 'can_manage_stock' },
      { key: 'supply_requests', icon: ShoppingCart, label: 'Solicitacoes de Compra', path: '/supply-requests', permission: 'can_manage_stock' },
      { key: 'material_releases', icon: ClipboardSignature, label: 'Liberacao de Material', path: '/material-releases', permission: 'can_manage_stock' },
      { key: 'material_returns', icon: Undo2, label: 'Devolucoes Pendentes', path: '/material-returns', permission: 'can_manage_stock' },
      { key: 'stock_alerts', icon: ShieldAlert, label: 'Alertas de Estoque', path: '/stock-alerts', permission: 'can_manage_materials', alertBadge: true },
    ],
  },
  {
    key: 'compras',
    label: 'Compras',
    defaultOpen: false,
    items: [
      { key: 'purchase_orders', icon: ShoppingCart, label: 'Pedidos de Compra', path: '/purchase-orders', permission: 'can_view_purchase_requests' },
      { key: 'po_shortage', icon: ShieldAlert, label: 'Faltas em POs', path: '/po-shortage', permission: 'can_view_purchase_requests' },
      { key: 'quotations', icon: FileText, label: 'Cotacoes', path: '/quotations', permission: 'can_manage_quotations' },
      { key: 'suppliers', icon: Truck, label: 'Fornecedores', path: '/suppliers', permission: 'can_manage_suppliers' },
      { key: 'purchase_dashboard', icon: BarChart3, label: 'Dashboard Compras', path: '/purchase-dashboard', permission: 'can_view_purchase_requests' },
    ],
  },
  {
    key: 'gamificacao',
    label: 'Gamificacao',
    defaultOpen: false,
    items: [
      { key: 'patents', icon: Award, label: 'Patentes', path: '/patents', permission: 'can_manage_patents' },
      { key: 'bonus_rules', icon: Trophy, label: 'Bonificacao', path: '/bonus-rules', permission: 'can_configure_bonus' },
      { key: 'redemptions', icon: Banknote, label: 'Resgates', path: '/redemptions', permission: 'can_manage_redemptions' },
      { key: 'my_coins', icon: Coins, label: 'Minhas Moedas', path: '/coins', permission: 'can_view_my_coins' },
      { key: 'tech_dashboard', icon: Gauge, label: 'Meu Painel', path: '/tech-dashboard', permission: 'can_view_my_panel' },
      { key: 'my_performance', icon: Flame, label: 'Meu Desempenho', path: '/my-performance', permission: 'can_view_my_panel' },
      { key: 'coin_extract', icon: Receipt, label: 'Extrato de Moedas', path: '/coin-extract', permission: 'can_view_my_coins' },
    ],
  },
  {
    key: 'ferramentas',
    label: 'FERRAMENTAS',
    defaultOpen: false,
    items: [
      { key: 'tools_management', icon: Wrench, label: 'Gestao de Ferramentas', path: '/tools', permission: 'can_manage_tools' },
    ],
  },
  {
    key: 'configuracoes',
    label: 'Configuracoes',
    defaultOpen: false,
    items: [
      { key: 'system_settings', icon: Settings, label: 'Configuracoes', path: '/system-settings', permission: 'can_manage_settings' },
      { key: 'company_settings', icon: Settings, label: 'Empresa', path: '/company-settings', permission: 'can_manage_settings' },
      { key: 'location_config', icon: Layers, label: 'Tipos de Local', path: '/location-config', permission: 'can_manage_settings' },
      { key: 'whatsapp_templates', icon: MessageSquare, label: 'Templates WhatsApp', path: '/whatsapp-templates', permission: 'can_manage_whatsapp_templates' },
      { key: 'whatsapp_logs', icon: ScrollText, label: 'Logs WhatsApp', path: '/whatsapp-logs', permission: 'can_view_whatsapp_logs' },
    ],
  },
];

export const ALL_MENU_ITEMS = MENU_GROUPS.flatMap(g => g.items);
export const ALL_PERMISSION_KEYS = [...new Set(ALL_MENU_ITEMS.filter(i => i.permission).map(i => i.permission))];
